import React, { useState } from 'react'; // ۱. اضافه کردن useState
import { FaRss, FaPlus, FaMinus, FaTrash, FaLightbulb } from "react-icons/fa"; // اضافه کردن آیکون‌های مثبت و منفی
import styles from '../../pages/Monitor/Monitor.module.css';

const RemoteControlCard = ({ data, onUpdate }) => {
    const [newCode, setNewCode] = useState('');
    const [isExpanded, setIsExpanded] = useState(false); // ۲. تعریف وضعیت برای گسترش لیست رله‌ها

    if (!data) return null;

    const { settings, triggered } = data;

    const codes = settings?.learnedRemote ? settings.learnedRemote.split(',').filter(c => c.trim() !== "") : [];
    const activeRelays = settings?.cDToDOut ? settings.cDToDOut.split(',').map(Number).filter(n => !isNaN(n)) : [];

    const addCode = () => {
        const trimmedCode = newCode.trim();
        const codeNum = parseInt(trimmedCode);
        
        if (!isNaN(codeNum) && codeNum >= 0 && codeNum <= 1048575 && !codes.includes(trimmedCode)) {
            const updatedList = [...codes, trimmedCode].join(',');
            onUpdate('learnedRemote', updatedList);
            setNewCode('');
        }
    };

    const removeCode = (codeToRemove) => {
        const updatedList = codes.filter(c => c !== codeToRemove).join(',');
        onUpdate('learnedRemote', updatedList);
    };

    const toggleRelay = (relayId) => {
        let newRelays;
        if (activeRelays.includes(relayId)) {
            newRelays = activeRelays.filter(r => r !== relayId);
        } else {
            newRelays = [...activeRelays, relayId].sort((a, b) => a - b);
        }
        onUpdate('cDToDOut', newRelays.join(','));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') addCode();
    };

    // ۳. تعیین تعداد رله‌های نمایشی بر اساس وضعیت isExpanded
    const relayList = [...Array(isExpanded ? 72 : 8).keys()];

    return (
        <div className={styles.sensorCard} style={{ borderRight: '4px solid #9b59b6' }}>
            <div className={styles.cardHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FaRss color="#9b59b6" />
                    <span style={{ fontWeight: 'bold' }}>ریموت کنترلر (RF 433)</span>
                </div>
                <FaLightbulb 
                    className={`${styles.trigIcon} ${triggered ? styles.trigOn : styles.trigOff}`}
                    title={triggered ? "دریافت سیگنال ریموت" : "وضعیت آماده‌باش"}
                    style={{ fontSize: '18px' }}
                />
            </div>

            <div className={styles.settingsGroup}>
                <div className={styles.settingRow}>
                    <span>اطلاع‌رسانی پیامکی:</span>
                    <label className={styles.toggleSwitch}>
                        <input 
                            type="checkbox" 
                            checked={settings?.alertSms === "1"} 
                            onChange={(e) => onUpdate('alertSms', e.target.checked ? "1" : "0")} 
                        />
                        <span className={styles.slider}></span>
                    </label>
                </div>

                {/* بخش رله‌ها با مدیریت نمایش */}
                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ fontSize: '13px', color: '#9b59b6', marginBottom: '8px' }}>
                        اتصال به خروجی‌ها ({isExpanded ? '۰-۷۱' : '۰-۷'}):
                    </span>
                    <div style={{ 
                        display: 'flex', flexWrap: 'wrap', gap: '4px', 
                        padding: '6px', background: 'rgba(0,0,0,0.2)', 
                        borderRadius: '4px', width: '100%',
                        border: '1px solid rgba(255,255,255,0.05)'
                    }}>
                        {relayList.map(r => (
                            <button 
                                key={r} onClick={() => toggleRelay(r)}
                                type="button"
                                style={{
                                    width: '22px', height: '22px', fontSize: '9px',
                                    backgroundColor: activeRelays.includes(r) ? '#2ecc71' : '#34495e',
                                    border: 'none', color: 'white', borderRadius: '3px', cursor: 'pointer'
                                }}
                            >
                                {r}
                            </button>
                        ))}

                        {/* ۴. دکمه نارنجی صنعتی برای باز و بسته کردن لیست */}
                        <button 
                            type="button"
                            className={styles.retroToggleBtn}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <FaMinus /> : <FaPlus />}
                        </button>
                    </div>
                    {activeRelays.length > 0 && (
                        <div style={{fontSize:'10px', color:'#95a5a6', marginTop:'5px'}}>
                            انتخاب شده: {activeRelays.join(', ')}
                        </div>
                    )}
                </div>

                <hr style={{ border: '0', borderTop: '1px solid #ffffff10', margin: '15px 0' }} />

                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                    <span style={{ marginBottom: '8px', fontSize: '13px', color: '#9b59b6' }}>مدیریت ریموت‌های مجاز (RF ID):</span>
                    <div style={{ display: 'flex', width: '100%', gap: '5px' }}>
                        <input 
                            className={styles.inputNum} 
                            style={{ flex: 1, textAlign: 'right', padding: '0 8px', fontSize: '12px' }}
                            placeholder="کد ریموت (0-1048575)"
                            type="number" 
                            value={newCode} 
                            onChange={(e) => setNewCode(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <button 
                            onClick={addCode} 
                            style={{ background: '#2ecc71', border: 'none', color: 'white', padding: '5px 12px', borderRadius: '4px', cursor: 'pointer' }}
                        >
                            <FaPlus />
                        </button>
                    </div>
                    
                    <div style={{ 
                        display: 'flex', flexDirection: 'column', width: '100%', gap: '5px', 
                        marginTop: '10px', maxHeight: '100px', overflowY: 'auto' 
                    }}>
                        {codes.map(code => (
                            <div key={code} style={{ 
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                background: 'rgba(255,255,255,0.05)', padding: '6px 10px', borderRadius: '4px', fontSize: '12px' 
                            }}>
                                <span style={{ fontFamily: 'monospace' }}>ID: {code}</span>
                                <FaTrash 
                                    style={{ color: '#e74c3c', cursor: 'pointer' }} 
                                    onClick={() => removeCode(code)} 
                                />
                            </div>
                        ))}
                        {codes.length === 0 && <small style={{ color: '#7f8c8d', textAlign: 'center', width: '100%' }}>لیست ریموت‌ها خالی است</small>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RemoteControlCard;